import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import Alert from 'components/ui/Alert';
import OrderRtbBanner from './OrderRtbBanner';
import _ from 'underscore';
import { isNil } from 'lodash';
import { humanize } from 'underscore.string';
import marked from 'marked';
import moment from 'moment';
import { arrayMove } from 'react-sortable-hoc';
import unitConverter from 'convert-units';
import { Menu } from '@headlessui/react';
import Badge from 'components/v2/Badge';
import DropdownMenu from 'components/v2/dropdowns/DropdownMenu';
import DropdownItem from 'components/v2/dropdowns/DropdownItem';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import DriverActionCreators from 'actions/DriverActionCreators';
import Accounting from 'components/modules/shipments/accounting/Accounting';
import PortIntegration from 'components/modules/equipment/PortIntegration';
// import { LegNumberSummary } from './LegNumberSummary/LegNumberSummary';
import StatusBar from 'components/modules/shipments/StatusBar';
import CloneShipmentModal from 'components/modules/shipments/CloneShipmentModal';
import ConfirmModal from 'components/ui/modals/ConfirmModal';
import CommentList from 'components/modules/comments/CommentList';
import ShipmentStore from 'stores/ShipmentStore';
import SessionStore from 'stores/SessionStore';
import DriverStore from 'stores/DriverStore';
import { showToast } from 'stores/ToastStore';
import ExceptionStore from 'stores/ExceptionStore';
import { getLatestStatus } from 'utils/formatters/shipments';
import AccessorialRequestActionCreators from 'actions/AccessorialRequestActionCreators';
import { approveCarrierCost, removeLineItem, } from 'utils/AccountingWebAPIUtils';
import { getAccessorialRequestsAutoDeclineDates, resolveAccessorialsStatus, } from 'utils/AccessorialRequestWebAPIUtils';
import CargomaticCard from 'components/v2/card';
import CargomaticTooltip from 'components/v2/Tooltip';
import FetchWebAPIUtils from 'utils/FetchWebAPIUtils';
import CargomaticPane from 'components/v2/pane';
import { getShipmentTimezone, isShipmentCanceled } from 'helpers/shipments';
import { isLegManagementEnabled } from 'helpers/legs-helper';
import ShipmentWebAPIUtils, { addHold } from 'utils/ShipmentWebAPIUtils';
import { withTranslation } from 'react-i18next';
import { INTERMODAL_TYPES } from 'constants/ShipmentTypes';
import { withLocaleContext } from 'providers/locale-settings-context';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import { userCanApproveAccessorials as userCanApproveAccessorialsHelper, checkIfAccessorialsNeedsReview, checkIfEquipmentIsMissing, } from 'helpers/accessorials';
import MarketplaceStatus from './MarketplaceStatus';
import SendDOEmailModal from './SendDOEmailModal';
import SendBolEmailModal from './SendBOLEmailModal';
import SendRATEEmailModal from './SendRATEEmailModal';
import SendEmailModal from './SendEmailModal';
import ShipmentDetails from './ShipmentDetails';
import ShipmentRoute from './ShipmentRoute';
import AssignDriverModal from './AssignDriverModal';
import ConfirmAssignCarrierModal from './ConfirmAssignCarrierModal';
import AddAccessorialModal from './accounting/AddAccessorialModal';
import AddOrAdjustDrayageAccessorialModal from './accounting/AddOrAdjustDrayageAccessorialModal';
import CancelShipmentModal from './CancelShipmentModal';
import AddIncentiveModal from './accounting/AddIncentiveModal';
import ShipmentReopenModal from './ShipmentReopenModal';
import GenerateLedgerModal from '../orders/accounting/GenerateLedgerModal';
import RerateCostModal from '../orders/accounting/RerateCostModal';
import AccessorialRequests from './accessorials/AccessorialRequests';
import { isDrayageOrRailShipment, isIntermodalShipmentType, } from '../../../helpers/shipment-types';
import BulkAddAccessorialsModal from './accounting/BulkAddAccessorialsModal';
import AccessorialRequestPane from './AccessorialRequestPane';
import { getDeliveryOrderRecipients } from '../../../helpers/shipments';
import AccessorialsConfirmationModal from './accessorials/ConfirmationModal';
import ShipmentStateDefinition from '../../../config/shipment-state-definitions';
import { generateOrderInvoice, generateOrderPayout, } from '../../../utils/OrderWebAPIUtils';
import AddButton from '../../v2/buttons/AddButton';
import Events from './events/Event';
import { RECEIVABLES } from '../../../constants/LedgerTypes';
import ShipmentHolds from './ShipmentHolds';
import ShipmentOnHoldModal from './ShipmentOnHoldModal';
import ShipperCostAdjustmentModel from './accounting/ShipperCostAdjustmentModel';
import { Documents } from '../documents/Documents';
import { ShipmentInvoiceDocumentPreferences } from './ShipmentInvoiceDocumentPreferences';
import MeteringTable from './MeteringTable';
import { OverrideBillingStatusModal } from './OverrideBillingStatusModal';
import { getUserInvoiceSettings, getPendingAccessorialInclusion, } from 'utils/UserServiceAPIUtils';
import ShipmentBridges from 'components/modules/shipments/ShipmentBridges.js';
import { FloatingAIAssistant } from './assistant/AIAssistant';
// import { Button } from '@cargomatic/ui';
// import { Sparkle } from 'lucide-react';
import HazmatDetails from '../orders/HazmatDetailsList';
// Removed feature-flag gates; using shipment.leg_management_version toggles instead
marked.setOptions({
    renderer: new marked.Renderer(),
    gfm: true,
    tables: true,
    breaks: false,
    pedantic: false,
    sanitize: true,
    smartLists: true,
    smartypants: false,
});
const CARGOMATIC = 'Cargomatic Inc.';
function clearMessage(shipmentId, index) {
    return () => {
        ShipmentsActionCreators.clearMessage(shipmentId, index);
    };
}
class Shipment extends Component {
    constructor(props) {
        super(props);
        this.getAccessorials = () => {
            AccessorialRequestActionCreators.getAccessorialRequests({
                shipment: getIdParam(this.props),
            });
        };
        this.checkNewlyProcessedLedgerItems = (prevShipment, newShipment, ledger) => {
            var _a, _b;
            const prevProcessedLedgerItems = (_a = (prevShipment[ledger] || [])) === null || _a === void 0 ? void 0 : _a.filter((item) => item === null || item === void 0 ? void 0 : item.processed);
            const newProcessedLedgerItems = (_b = (newShipment[ledger] || [])) === null || _b === void 0 ? void 0 : _b.filter((item) => item === null || item === void 0 ? void 0 : item.processed);
            return (prevProcessedLedgerItems === null || prevProcessedLedgerItems === void 0 ? void 0 : prevProcessedLedgerItems.length) !== (newProcessedLedgerItems === null || newProcessedLedgerItems === void 0 ? void 0 : newProcessedLedgerItems.length);
        };
        this.handleAccessorialRequestChange = async () => {
            if (getIdParam(this.props)) {
                const shipmentId = getIdParam(this.props);
                const accessorialRequests = ExceptionStore.getShipmentAccessorialRequests(shipmentId);
                const accessorialRequestIds = getAccessorialRequestIds(accessorialRequests);
                let shipperAutoDeclineDates = {};
                const accessorialIdsWithMissingDocs = getAccessorialRequestIdsWithMissingDocs(accessorialRequests);
                if (accessorialRequests && accessorialRequests.length > 0) {
                    if (featureEnabled(CONFIGURED_FEATURES.SSR) &&
                        isIntermodalShipmentType(this.state.shipment) &&
                        (accessorialIdsWithMissingDocs === null || accessorialIdsWithMissingDocs === void 0 ? void 0 : accessorialIdsWithMissingDocs.length)) {
                        shipperAutoDeclineDates = await this.getShipperAutoDeclineDates(accessorialIdsWithMissingDocs);
                    }
                    const accessorials = accessorialRequests.map((ar) => {
                        const shipperAutoDeclineDate = shipperAutoDeclineDates[ar._id.toString()];
                        return Object.assign(Object.assign({}, ar), { shipperAutoDeclineDate });
                    });
                    this.setState({ accessorials, accessorialRequestIds });
                }
                else {
                    this.setState({ accessorials: [], accessorialRequestIds: [] });
                }
            }
        };
        this.getShipperAutoDeclineDates = async (accessorialRequestIds) => {
            var _a;
            const { t } = this.props;
            try {
                const result = await getAccessorialRequestsAutoDeclineDates(accessorialRequestIds);
                const items = ((_a = result === null || result === void 0 ? void 0 : result.entity) === null || _a === void 0 ? void 0 : _a.items) || [];
                return items.reduce((dates, { _id, shipper_auto_decline_date }) => {
                    dates[_id] = shipper_auto_decline_date;
                    return dates;
                }, {});
            }
            catch (e) {
                showToast(t('ACCESSORIAL_REQUEST_ERROR'), t('ERROR_RETRIEVING_SHIPPER_ACCESSORIAL_REQUEST_AUTO_DECLINE_DATE'), 'error');
                console.error(`Error retrieving shipper accessorial request auto decline date: ${e.message}`);
                return {};
            }
        };
        this.getDriverWaypoints = () => {
            const { shipment } = this.state;
            if (shipment && shipment.accepted && this.state.waypointsEnabled) {
                let start;
                if (isIntermodalShipmentType(shipment)) {
                    const firstStop = shipment.stops.find((s) => s.sequence === 1);
                    if (firstStop && firstStop.timeline.complete) {
                        start = firstStop.timeline.complete.at;
                    }
                    else {
                        start = shipment.deliver_by;
                    }
                }
                else if (shipment.timeline &&
                    shipment.timeline.accepted &&
                    shipment.timeline.accepted.at) {
                    start = shipment.timeline.accepted.at;
                }
                else {
                    start = shipment.pickup_after;
                }
                const end = this.getEndOfWaypoints(shipment);
                DriverActionCreators.getDriverWaypoints(this.state.shipment.driver._id, start, end);
            }
        };
        this.refreshShipment = () => {
            this.getShipment(getIdParam(this.props));
        };
        this.handleRerateCosts = (shipment, costsToBeRerated) => {
            ShipmentsActionCreators.rerateShipmentCosts(shipment, costsToBeRerated);
        };
        this.handleGenerateLedger = async (ledgerDate, selectedCharges, sendEdi = false, sendEmail = false) => {
            const { t } = this.props;
            const { shipment: { order: { _id: orderId }, }, ledgerType, } = this.state;
            this.setState({
                showGenerateLedgerModal: false,
            });
            try {
                if (ledgerType === RECEIVABLES) {
                    await generateOrderInvoice(orderId, ledgerDate, selectedCharges, sendEdi, sendEmail, true);
                    showToast(t('INVOICE_GENERATION_SUCCESS'));
                    this.refreshShipment();
                }
                else {
                    await generateOrderPayout(orderId, ledgerDate, selectedCharges, true);
                    showToast(t('PAYOUT_GENERATION_SUCCESS'));
                    this.refreshShipment();
                }
            }
            catch (_a) {
                if (ledgerType === RECEIVABLES) {
                    showToast(t('INVOICE_GENERATION_FAILURE'), null, 'error');
                }
                else {
                    showToast(t('PAYOUT_GENERATION_FAILURE'), null, 'error');
                }
            }
        };
        this.handleShowGenerateLedgerModal = (ledgerType) => () => {
            this.setState({
                ledgerType,
                showGenerateLedgerModal: true,
            });
        };
        this.handleShowRerateCostModal = () => {
            this.setState({
                showRerateCostModal: true,
            });
        };
        this.handleHideOverrideBillingStatusModal = () => {
            this.setState({
                showOverrideBillingStatusModal: false,
            });
        };
        this.handleHideRerateCostModal = () => {
            this.setState({
                showRerateCostModal: false,
            });
        };
        this.handleHideGenerateLedgerModal = () => {
            this.setState({
                ledgerType: null,
                showGenerateLedgerModal: false,
            });
        };
        this.updateMissingReferenceNumbers = (missingRefs = []) => {
            if (missingRefs === null || missingRefs === void 0 ? void 0 : missingRefs.length) {
                this.setState({ missingReferenceNumbersList: missingRefs });
            }
        };
        this.handleAdjustmentsUpdate = () => this.setState({ customAdjustment: null, adjustmentToRemove: null });
        this.handleEditAdjustment = async (editedAdjustments) => {
            try {
                const { shipment } = this.state;
                const adjustmentIds = editedAdjustments.map((a) => a._id);
                const { ledger } = editedAdjustments[0];
                const adjustments = _.clone(shipment[ledger]);
                const modifiedAdjustments = adjustments.filter((a) => adjustmentIds && adjustmentIds.includes(a._id));
                if (!modifiedAdjustments || !modifiedAdjustments.length)
                    return;
                modifiedAdjustments.forEach((modifiedAdjustment) => {
                    const adjustment = editedAdjustments.find((a) => a._id === modifiedAdjustment._id);
                    Object.keys(adjustment).forEach((key) => {
                        if (key === 'value') {
                            modifiedAdjustment[key] = parseFloat(adjustment[key]);
                        }
                        else {
                            modifiedAdjustment[key] = adjustment[key];
                        }
                    });
                });
                await ShipmentWebAPIUtils.updateShipmentAdjustments(shipment, ledger, modifiedAdjustments);
                this.refreshShipment();
            }
            catch (e) {
                console.error(e);
            }
        };
        this.handleAddComment = async (comment) => {
            const { t } = this.props;
            try {
                const result = await ShipmentWebAPIUtils.addComment(this.state.shipment._id, comment);
                if (result && result.entity && result.entity.success) {
                    showToast(t('COMMENT_UPDATED_SUCCESSFULLY'), '', 'success');
                }
            }
            catch (e) {
                console.error(e);
                showToast(t('COMMENT_UPDATE_FAILED'), t('COULDNT_UPDATE_COMMENT', { message: e.message }), 'error');
            }
        };
        this.handleAccessorialError = () => {
            const error = ShipmentStore.getAddAccessorialError();
            this.setState({
                accessorialError: error ? { error } : null,
            });
        };
        this.handleSortStops = (oldIndex, newIndex) => {
            this.setState((prevState) => {
                const stops = arrayMove(prevState.stops, oldIndex, newIndex).map((stop, i) => (Object.assign(Object.assign({}, stop), { sequence: i + 1 })));
                return {
                    stops,
                };
            }, () => {
                const mappedSequences = this.state.stops.reduce((updates, stop) => {
                    updates[stop._id] = stop.sequence;
                    return updates;
                }, {});
                ShipmentsActionCreators.updateStopSequences(this.state.shipment, mappedSequences);
            });
        };
        this.handleShowCustomBulkAccessorialModal = () => {
            this.setState({ showBulkAccessorialModal: true });
        };
        this.handleHideCustomAccessorialModal = () => this.setState({
            customAdjustment: null,
            showAddOrAdjustDrayageAccessorialModal: false,
        });
        this.handleAddCustomAdjustment = (customAdjustment) => {
            this.setState({
                customAdjustment,
                showAddOrAdjustDrayageAccessorialModal: true,
            });
        };
        this.handleShowShipperCostAdjustmentModel = (lineItem) => {
            this.setState({
                selectedLineItemForAdjustment: lineItem,
                showShipperChargeAdjustmentModal: true,
            });
        };
        this.handleHideShipperCostAdjustmentModel = () => {
            this.setState({
                showShipperChargeAdjustmentModal: false,
            });
        };
        this.handleShowSendFeesDueEmailModal = () => {
            this.setState({ showSendFeesDueEmailModal: true });
        };
        this.handleHideSendFeesDueEmailModal = () => {
            this.setState({ showSendFeesDueEmailModal: false });
        };
        this.handleAddCustomAccessorial = (adjustments) => {
            this.setState({ showAddOrAdjustDrayageAccessorialModal: false });
            adjustments.forEach((data) => {
                const { ledger, adjustment } = data;
                ShipmentsActionCreators.addAdjustment(this.state.shipment, ledger, adjustment);
            });
        };
        this.handleShipperCostAdjustment = (adjustment) => {
            const transformedLedgerItem = {
                ledger: adjustment.ledger,
                message: 'Shipper Cost Adjustment',
                reason: adjustment.reasonCode,
                notes: adjustment.note,
                equipment: adjustment.derivedEquipment,
                value: adjustment.shipperCost,
                category: 'base_cost',
                type: 'shipper_cost',
                appointment: false,
                adjustedItem: 'base_cost',
            };
            ShipmentsActionCreators.addAdjustment(this.state.shipment, transformedLedgerItem.ledger, transformedLedgerItem);
            this.setState({ showShipperChargeAdjustmentModal: false });
        };
        this.handleAddBaseCost = async (ledgerType, baseCostLedger) => {
            const { shipment } = this.state;
            if (shipment.shipment_type === 'shorthaul') {
                baseCostLedger.message = 'Base Cost';
            }
            else if (ledgerType === 'payables') {
                baseCostLedger.message = 'Carrier Cost';
            }
            else {
                baseCostLedger.message = 'Shipper Cost';
            }
            const response = await ShipmentWebAPIUtils.addBaseCost(shipment._id, ledgerType, baseCostLedger);
            this.refreshShipment();
            if (response.entity.error) {
                console.log(response.entity.error);
                return false;
            }
            return true;
        };
        this.handleApproveBaseCost = async (ledger) => {
            const { t } = this.props;
            const { shipment } = this.state;
            try {
                await approveCarrierCost(shipment._id, ledger._id);
                showToast(t('APPROVE_CARRIER_COST'), t('CARRIER_COST_APPROVAL_SUCCESS'));
                this.refreshShipment();
            }
            catch (e) {
                console.error(e);
                showToast(t('APPROVE_CARRIER_COST'), t('CARRIER_COST_APPROVAL_FAILURE'), 'error');
            }
        };
        this.handleRemoveLineItem = async (lineItem, type) => {
            const { t } = this.props;
            const { shipment: { _id }, } = this.state;
            try {
                await removeLineItem(lineItem._id, type, _id);
                this.refreshShipment();
                showToast(t('REMOVE_LINE_ITEM'), t('REMOVE_LINE_ITEM_SUCCESS'));
            }
            catch (e) {
                console.error(e);
                showToast(t('REMOVE_LINE_ITEM'), t('REMOVE_LINE_ITEM_FAILED', { error: e.message }), 'error');
            }
        };
        this.handleCancelConfirmModal = () => this.setState({
            confirmModalTitle: '',
            confirmModalMessage: '',
            showConfirmModal: false,
        });
        this.handleCloseCloneShipmentModal = () => {
            this.setState({
                showCloneShipmentModal: false,
            });
        };
        this.handleCloneShipment = (options) => {
            this.handleCloseCloneShipmentModal();
            this.confirmCloneShipment(options);
        };
        this.handleRemoveAdjustment = ({ _id, ledger }) => {
            const { t } = this.props;
            this.setState({
                confirmModalTitle: t('REMOVE_ADJUSTMENT'),
                confirmModalMessage: t('REMOVE_ADJUSTMENT_CONFIRMATION'),
                showConfirmModal: true,
                showAddOrAdjustDrayageAccessorialModal: false,
                adjustmentToRemove: { _id, ledger },
            });
        };
        this.handleRemoveAdjustmentConfirm = () => {
            const { shipment, adjustmentToRemove: { ledger, _id }, } = this.state;
            const update = {};
            const accessorialIndex = shipment[ledger].findIndex((a) => a._id === _id);
            if (accessorialIndex === -1) {
                this.closeConfirmModal();
                return;
            }
            shipment[ledger].splice(accessorialIndex, 1);
            update[ledger] = shipment[ledger];
            ShipmentsActionCreators.updateAdjustments(this.state.shipment, update);
            this.closeConfirmModal();
        };
        this.handleConfirmStateTransitionModal = () => {
            ShipmentsActionCreators.transitionTo(this.state.shipment, this.state.nextState.status, this.state.nextState.meta);
            this.handleHideConfirmStateTransitionModal();
        };
        this.handleUpdateShipmentEquipmentType = (shipment, values) => {
            ShipmentsActionCreators.updateEquipmentType(shipment, values);
        };
        this.fetchShipperInvoiceSettings = async (shipperId = '') => {
            var _a, _b, _c, _d;
            if (shipperId) {
                try {
                    const [invoiceSettingsResult, pendingAccessorialsResult] = await Promise.all([
                        getUserInvoiceSettings(shipperId),
                        getPendingAccessorialInclusion(shipperId),
                    ]);
                    const invoiceSettings = (_b = (_a = invoiceSettingsResult === null || invoiceSettingsResult === void 0 ? void 0 : invoiceSettingsResult.data) === null || _a === void 0 ? void 0 : _a.getInvoiceSetting) === null || _b === void 0 ? void 0 : _b.invoice_setting;
                    const pendingAccessorialInclusion = !!((_d = (_c = pendingAccessorialsResult.data) === null || _c === void 0 ? void 0 : _c.getBillReadyStatusCalculation) === null || _d === void 0 ? void 0 : _d.include_pending_accessorials_in_calculation);
                    this.setState({
                        shipperInvoiceSettings: invoiceSettings,
                        pendingAccessorialInclusion,
                    });
                }
                catch (e) {
                    this.setState({
                        shipperInvoiceSettings: null,
                        pendingAccessorialInclusion: false,
                    });
                    console.error(e);
                }
            }
        };
        this._onAuditsChange = () => {
            const id = getIdParam(this.props);
            this.setState((prevState) => {
                return Object.assign({}, prevState, this.getStateFromStores(id));
            });
        };
        this._onChange = () => {
            const id = getIdParam(this.props);
            this.setState((prevState) => {
                return Object.assign({}, prevState, this.getStateFromStores(id));
            }, async () => {
                var _a, _b, _c, _d;
                await Promise.all([
                    this.fetchShipperInvoiceSettings((_b = (_a = this.state.shipment) === null || _a === void 0 ? void 0 : _a.shipper) === null || _b === void 0 ? void 0 : _b._id),
                    this.getStateTransitions(),
                ]);
                (_d = (_c = this.state).documentsRefetch) === null || _d === void 0 ? void 0 : _d.call(_c);
            });
        };
        this.setDocumentsRefetchRef = (documentsRefetch) => {
            this.setState({
                documentsRefetch,
            });
        };
        this._onDriverWaypoints = () => {
            const waypoints = DriverStore.getDriverWaypoints();
            if (waypoints && waypoints.coords && waypoints.coords.length > 0) {
                this.setState({ waypoints: waypoints.coords });
            }
        };
        this.setShouldDisableAllAccessorialActions = (selectedAccessorialRequests = []) => {
            const shouldDisableAllAccessorialActions = !selectedAccessorialRequests.length;
            this.setState({ shouldDisableAllAccessorialActions });
        };
        this.handleAccessorialActionSelect = (accessorialAction) => {
            if (accessorialAction === 'edit_all')
                return this.setState({
                    showBulkAccessorialModal: true,
                    bulkAccessorialModalEditMode: true,
                });
            this.setState({ accessorialAction });
        };
        this.handleAccessorialRequestSelect = (selectedAccessorialRequests) => this.setState({ selectedAccessorialRequests }, () => this.setShouldDisableAllAccessorialActions(selectedAccessorialRequests));
        this.handleAccessorialOnSubmit = async (payload) => {
            var _a, _b;
            try {
                const { t } = this.props;
                if (this.state.accessorialAction === 'notify_all') {
                    AccessorialRequestActionCreators.updateAccessorialRequest(payload);
                    return this.setState({
                        accessorialAction: '',
                        selectedAccessorialRequests: [],
                    });
                }
                const { entity: { result }, } = await resolveAccessorialsStatus(payload);
                const errors = result.errors || [];
                const successes = result.successes || [];
                if ((_a = errors[0]) === null || _a === void 0 ? void 0 : _a.job) {
                    this.refreshShipment();
                    const approveAccessorialsWarning = successes.length > 0
                        ? t('ACCESSORIAL_UPDATE_CARRIER_SOME_EMAIL_NOT_SENT', {
                            error: humanize(errors[0].error),
                        })
                        : t('ACCESSORIAL_UPDATE_CARRIER_ALL_EMAIL_NOT_SENT', {
                            error: humanize(errors[0].error),
                        });
                    showToast(t('APPROVE_ACCESSORIALS'), approveAccessorialsWarning, 'warning');
                }
                else if ((_b = successes[0]) === null || _b === void 0 ? void 0 : _b.job) {
                    // this.refreshShipment();
                    // this.setState({ shipment: successes[0].job });
                    if (this.state.accessorialAction === 'approve_all') {
                        showToast(t('APPROVE_ACCESSORIALS'), t('APPROVE_ACCESSORIALS_SUCCESS'), 'success');
                    }
                    else {
                        showToast(t('DECLINE_ACCESSORIALS'), t('DECLINE_ACCESSORIALS_SUCCESS'), 'success');
                    }
                }
                else if (errors === null || errors === void 0 ? void 0 : errors.length) {
                    errors.forEach(({ error }) => {
                        const title = this.state.accessorialAction === 'approve_all'
                            ? 'APPROVE_ACCESSORIALS'
                            : 'DECLINE_ACCESSORIALS';
                        showToast(t(title), error, 'error');
                    });
                }
                return this.setState({
                    accessorialAction: '',
                    selectedAccessorialRequests: [],
                }, () => this.getAccessorials());
            }
            catch (e) {
                showToast(e.message, null, 'error');
            }
        };
        this.handleAccessorialRemove = (accessorialId) => {
            this.setState((prevState) => {
                return {
                    selectedAccessorialRequests: prevState.selectedAccessorialRequests.filter((acc) => acc._id !== accessorialId),
                };
            });
        };
        this.userCanApproveAccessorials = () => {
            const { selectedAccessorialRequests } = this.state;
            const user = SessionStore.getUser();
            const autoAppliedNeedsReviewAccessorialPresent = checkIfAccessorialsNeedsReview(selectedAccessorialRequests);
            return (userCanApproveAccessorialsHelper(user, selectedAccessorialRequests) &&
                !autoAppliedNeedsReviewAccessorialPresent);
        };
        this.isMissingDocs = (accessorials) => {
            return accessorials.some((acc) => acc.hasOwnProperty('missing_docs') && !!(acc === null || acc === void 0 ? void 0 : acc.missing_docs));
        };
        this.renderAccessorialRequestsPanelHeader = () => {
            const { shipment, shouldDisableAllAccessorialActions, selectedAccessorialRequests, } = this.state;
            const { t } = this.props;
            const autoAppliedNeedsReviewAccessorialPresent = checkIfAccessorialsNeedsReview(selectedAccessorialRequests);
            const missingEquipment = checkIfEquipmentIsMissing(selectedAccessorialRequests);
            return (React.createElement("div", { "data-testid": "div-5d91e3af", id: "accessorial-requests-actions-dropdown", className: "" },
                React.createElement("div", { "data-testid": "div-13180b0e", className: "flex justify-between my-auto", onClick: (e) => e.stopPropagation() },
                    React.createElement(DropdownButton, { id: "accessorial-actions", title: t('ACTIONS'), onSelect: this.handleAccessorialActionSelect, disabled: shouldDisableAllAccessorialActions },
                        React.createElement(MenuItem, { disabled: !SessionStore.isAdmin(), eventKey: "edit_all" }, t('EDIT_ACCESSORIAL')),
                        React.createElement(MenuItem, { eventKey: "approve_all", disabled: !this.userCanApproveAccessorials() || missingEquipment }, t('APPROVE')),
                        React.createElement(MenuItem, { eventKey: "decline_all" }, t('DECLINE')),
                        React.createElement(MenuItem, { eventKey: "notify_all", disabled: autoAppliedNeedsReviewAccessorialPresent || missingEquipment }, t('NOTIFY_SHIPPER'))),
                    this.state.shipment && (React.createElement("div", { "data-testid": "div-aaf8ea45", className: "ml-4" },
                        React.createElement(AddButton, { dataTestId: "AddButton-a75e1cff", onClick: this.handleShowCustomBulkAccessorialModal, disabled: isShipmentCanceled(shipment) }))))));
        };
        this.handleShowAccessorialRequestPane = (accessorial) => {
            this.setState({
                selectedAccessorialRequest: accessorial._id,
                showAccessorialRequestPane: true,
            });
        };
        this.hideAccessorialRequestPane = () => {
            this.setState({ showAccessorialRequestPane: false });
        };
        this.isMissingReferenceNumbers = () => {
            const { shipment } = this.state;
            if (shipment && INTERMODAL_TYPES.includes(shipment.shipment_type)) {
                return shipment.missing_reference_numbers;
            }
            return false;
        };
        this.handleStateTransition = (shipment, status, meta) => {
            this.setState({
                showConfirmStateTransitionModal: true,
                nextState: { status, meta },
            });
        };
        this._getDeliveryOrderRecipients = () => {
            const { carrier } = this.state.shipment;
            return getDeliveryOrderRecipients(carrier);
        };
        this.removeCarrier = async () => {
            const { shipment: { _id }, } = this.state;
            const result = await ShipmentWebAPIUtils.removeCarrier(_id);
            if (result) {
                this.setState({ /*shipment: result,*/ showConfirmRemoveModal: false });
                this.refreshShipment();
            }
        };
        this.generateCarrier204 = (event) => ShipmentWebAPIUtils.generateCarrier204(this.state.shipment._id, event);
        this.setShowHoldModal = (show) => {
            this.setState({ showHoldModal: show });
        };
        this.onSaveHold = (hold) => {
            this.setState({ isLoadingHolds: true }, async () => {
                const { shipment } = this.state;
                const response = await addHold(shipment._id, hold);
                if (response) {
                    // shipment.holds = response.holds;
                    this.setState({ showHoldModal: false, isLoadingHolds: false });
                    this.refreshShipment();
                }
            });
        };
        this.handleHideConfirmStateTransitionModal = () => {
            this.setState((prevState) => ({
                showConfirmStateTransitionModal: !prevState.showConfirmStateTransitionModal,
            }));
        };
        this.state = {
            isAdmin: SessionStore.isAccessorialsAdmin(),
            showHoldModal: false,
            showOverrideBillingStatusModal: false,
            showAddAccessorialModal: false,
            showSendDOEmailModal: false,
            showSendFeesDueEmailModal: false,
            showSendBOLEmailModal: false,
            showSendRATEEmailModal: false,
            showAddOrAdjustDrayageAccessorialModal: false,
            showShipperChargeAdjustmentModal: false,
            showIncentiveModal: false,
            showAssignDriverModal: false,
            showConfirmAssignCarrierModal: false,
            showCloneShipmentModal: false,
            showCancelShipmentModal: false,
            showShipmentReOpenModal: false,
            showRerateCostModal: false,
            showConfirmModal: false,
            showConfirmRemoveModal: false,
            showConfirmStateTransitionModal: false,
            shipment: null,
            timezone: 'America/Los_Angeles',
            isLoadingHolds: false,
            stops: [],
            audits: [],
            waypoints: [],
            waypointsEnabled: false,
            customAdjustment: null,
            confirmModalMessage: '',
            confirmModalTitle: '',
            progress: {},
            regress: {},
            nextState: {},
            selectedAccessorialRequests: [],
            showAccessorialRequestPane: false,
            selectedAccessorialRequest: null,
            selectedLineItemForCredit: null,
            selectedLineItemForAdjustment: null,
            disableSaveCreateCreditMemoButton: false,
            documentsRefetch: null,
            accessorials: [],
            accessorialRequestIds: [],
            brokerCarrierDriver: null,
            shouldDisableAllAccessorialActions: true,
            bulkAccessorialModalEditMode: false,
            shipperInvoiceSettings: null,
            pendingAccessorialInclusion: false,
            missingReferenceNumbersList: [],
        };
    }
    componentDidMount() {
        this.getAccessorials();
        const id = getIdParam(this.props);
        ShipmentsActionCreators.getShipmentAuditEvents(id);
        ShipmentsActionCreators.getShipmentV2(id);
        ShipmentStore.addChangeListener(this._onChange);
        ShipmentStore.addShipmentAuditsChangeListener(this._onAuditsChange);
        DriverStore.addChangeListener(this._onDriverWaypoints);
        ShipmentStore.addAdjustmentsChangeListener(this.handleAdjustmentsUpdate);
        ShipmentStore.addAccessorialChangeListener(this.handleAccessorialError);
        ExceptionStore.addChangeListener(this.handleAccessorialRequestChange);
    }
    componentDidUpdate(prevProps, prevState) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        const getAccessorialConditionList = [
            getIdParam(this.props) !== getIdParam(prevProps),
            ((_a = prevState === null || prevState === void 0 ? void 0 : prevState.shipment) === null || _a === void 0 ? void 0 : _a.status) !== ((_c = (_b = this.state) === null || _b === void 0 ? void 0 : _b.shipment) === null || _c === void 0 ? void 0 : _c.status),
            ((_e = (_d = prevState === null || prevState === void 0 ? void 0 : prevState.shipment) === null || _d === void 0 ? void 0 : _d.carrier) === null || _e === void 0 ? void 0 : _e._id) !== ((_h = (_g = (_f = this.state) === null || _f === void 0 ? void 0 : _f.shipment) === null || _g === void 0 ? void 0 : _g.carrier) === null || _h === void 0 ? void 0 : _h._id),
            ((_k = (_j = prevState === null || prevState === void 0 ? void 0 : prevState.shipment) === null || _j === void 0 ? void 0 : _j.receivables) === null || _k === void 0 ? void 0 : _k.length) !==
                ((_o = (_m = (_l = this.state) === null || _l === void 0 ? void 0 : _l.shipment) === null || _m === void 0 ? void 0 : _m.receivables) === null || _o === void 0 ? void 0 : _o.length),
            ((_q = (_p = prevState === null || prevState === void 0 ? void 0 : prevState.shipment) === null || _p === void 0 ? void 0 : _p.payables) === null || _q === void 0 ? void 0 : _q.length) !==
                ((_t = (_s = (_r = this.state) === null || _r === void 0 ? void 0 : _r.shipment) === null || _s === void 0 ? void 0 : _s.payables) === null || _t === void 0 ? void 0 : _t.length),
        ];
        if (prevState === null || prevState === void 0 ? void 0 : prevState.shipment) {
            getAccessorialConditionList.push(this.checkNewlyProcessedLedgerItems(prevState === null || prevState === void 0 ? void 0 : prevState.shipment, (_u = this.state) === null || _u === void 0 ? void 0 : _u.shipment, 'receivables'));
            getAccessorialConditionList.push(this.checkNewlyProcessedLedgerItems(prevState === null || prevState === void 0 ? void 0 : prevState.shipment, (_v = this.state) === null || _v === void 0 ? void 0 : _v.shipment, 'payables'));
        }
        if (getAccessorialConditionList.includes(true))
            this.getAccessorials();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (this.state.shipment) {
            if (nextProps.shipment &&
                nextProps.shipment._id !== this.state.shipment._id) {
                return this.getShipment(nextProps.shipment._id);
            }
            if (((_b = (_a = nextProps.match) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.id) &&
                ((_e = (_d = (_c = this.props) === null || _c === void 0 ? void 0 : _c.match) === null || _d === void 0 ? void 0 : _d.params) === null || _e === void 0 ? void 0 : _e.id) !== ((_g = (_f = nextProps.match) === null || _f === void 0 ? void 0 : _f.params) === null || _g === void 0 ? void 0 : _g.id)) {
                return this.getShipment(nextProps.match.params.id);
            }
        }
    }
    componentWillUnmount() {
        ShipmentStore.removeChangeListener(this._onChange);
        ShipmentStore.removeShipmentAuditsChangeListener(this._onAuditsChange);
        DriverStore.removeChangeListener(this._onDriverWaypoints);
        ShipmentStore.removeAdjustmentsChangeListener(this.handleAdjustmentsUpdate);
        ShipmentStore.removeAccessorialChangeListener(this.handleAccessorialError);
        ExceptionStore.removeChangeListener(this.handleAccessorialRequestChange);
        document.title = CARGOMATIC;
    }
    getEndOfWaypoints(shipment) {
        if (shipment.current) {
            return moment().toISOString();
        }
        const latestStatus = getLatestStatus(shipment);
        if (latestStatus && latestStatus.at) {
            return latestStatus.at;
        }
        return moment().toISOString();
    }
    getShipment(shipment_id = null) {
        let id = '';
        if (shipment_id) {
            id = shipment_id;
        }
        else {
            const { _id } = this.state.shipment;
            id = _id || this.props.match.params.id;
        }
        ShipmentsActionCreators.getShipmentAuditEvents(id);
        ShipmentsActionCreators.getShipmentV2(id);
        this.getDriverWaypoints();
    }
    getStateFromStores(id) {
        const shipment = ShipmentStore.getShipment(id);
        const stops = _.sortBy(shipment.stops || [], (s) => s.sequence);
        const intermodalShipment = isIntermodalShipmentType(shipment);
        return {
            shipment,
            timezone: getShipmentTimezone(shipment),
            intermodalShipment,
            stops,
            messages: ShipmentStore.getMessages(id),
            audits: ShipmentStore.getShipmentAudit(),
        };
    }
    sendDeliveryOrder() {
        return (emails) => {
            ShipmentsActionCreators.sendDeliveryOrder(this.state.shipment._id, emails);
        };
    }
    sendBolEmail() {
        // Set hardcode this to true until conditional logic is created in future ticket
        return (emails, toSend) => {
            ShipmentsActionCreators.processBol(this.state.shipment._id, emails, toSend);
        };
    }
    closeConfirmModal() {
        this.setState({
            showConfirmModal: false,
        });
    }
    handleWaypointsSelect() {
        this.setState((prevState) => ({ waypointsEnabled: !prevState.waypointsEnabled }), () => {
            this.getDriverWaypoints();
        });
    }
    addIncentive() {
        return (adjustment) => {
            ShipmentsActionCreators.addAdjustment(this.state.shipment, 'payables', adjustment);
        };
    }
    confirmCloneShipment(options) {
        ShipmentsActionCreators.cloneShipment(this.state.shipment, options);
    }
    async getStateTransitions() {
        const { shipment } = this.state;
        if (!_.isEmpty(shipment)) {
            const result = await FetchWebAPIUtils.getForwardRegress({ shipment });
            const { progress, regress } = result;
            this.setState({ progress, regress });
        }
    }
    renderMessages() {
        if (!this.state.messages)
            return null;
        return this.state.messages
            .filter((message) => {
            return !(message.includes('base payable rate') &&
                isIntermodalShipmentType(this.state.shipment));
        })
            .map((message, i) => (React.createElement(Alert, { key: "message", onDismiss: clearMessage(this.state.shipment._id, i) },
            React.createElement("div", { "data-testid": `div-035f2609-${i}`, dangerouslySetInnerHTML: { __html: marked(message) } }))));
    }
    renderPortIntegration(shipment) {
        return React.createElement(PortIntegration, { data: shipment, isShipment: true });
    }
    renderAccountingPanel(shipment, accessorialRequests = []) {
        return (React.createElement(Accounting, { shipment: shipment, accessorialRequests: accessorialRequests, refreshShipment: this.refreshShipment, onAddCustomAdjustment: this.handleAddCustomAdjustment, onAddShipperCostAdjustment: (lineItem) => this.handleShowShipperCostAdjustmentModel(lineItem), onAddBaseCost: this.handleAddBaseCost, onApproveBaseCost: this.handleApproveBaseCost, onRemoveLineItem: this.handleRemoveLineItem }));
    }
    renderAccessorialRequests(shipment) {
        return (React.createElement(AccessorialRequests, { dontRefresh: this.props.dontRefresh, shipment: shipment, accessorials: this.state.accessorials, accessorialRequestIds: this.state.accessorialRequestIds, selectedAccessorials: this.state.selectedAccessorialRequests.map((acc) => acc._id), onAccessorialSelect: this.handleAccessorialRequestSelect, handleRequestSelect: this.handleShowAccessorialRequestPane }));
    }
    getDetailComponent() {
        const { selectedAccessorialRequest, shipment } = this.state;
        const shipmentId = shipment === null || shipment === void 0 ? void 0 : shipment._id;
        return (React.createElement(AccessorialRequestPane, { accessorial: selectedAccessorialRequest, shipment: shipmentId, showAccessorialRequestPane: true, onSave: () => {
                if (shipmentId) {
                    ShipmentsActionCreators.getShipment(shipmentId, true);
                }
            } }));
    }
    renderPane() {
        if (!this.state.showAccessorialRequestPane) {
            return null;
        }
        const { t } = this.props;
        return (React.createElement("div", { "data-testid": "div-5c46df79" },
            React.createElement("div", { "data-testid": "div-73ca0221", id: "pane-container" }),
            React.createElement(CargomaticPane, { dataTestId: "CargomaticPane-4c364bda", show: this.state.showAccessorialRequestPane, title: t('ACCESSORIAL_REQUESTS'), onHide: () => this.hideAccessorialRequestPane(), renderBody: () => this.getDetailComponent(), className: "sm:w-1/3 sm:max-w-none", location: "right" })));
    }
    getStateTransitionMessage(status) {
        const { t } = this.props;
        if (ShipmentStateDefinition[status] &&
            ShipmentStateDefinition[status].description) {
            return (React.createElement("div", { "data-testid": "div-be22175b" },
                React.createElement("div", { "data-testid": "div-fecf82ec" },
                    React.createElement("span", { "data-testid": "span-c1254e25" }, t(ShipmentStateDefinition[status].description))),
                React.createElement("div", { "data-testid": "div-807637d5", className: "mt-4" },
                    React.createElement("span", { "data-testid": "span-20e1a0b7" }, t('CONFIRM_IF_SURE')))));
        }
        return t('CHANGE_JOB_STATUS_CONFIRMATION', { status });
    }
    render() {
        var _a, _b, _c, _d;
        const shipment = this.state.shipment;
        const { t, localeData } = this.props;
        if (_.isEmpty(shipment))
            return React.createElement("div", { "data-testid": "div-b7ef1db3" }, t('LOADING'));
        const deliveryOrderRecipient = this._getDeliveryOrderRecipients();
        shipment.exceptions = _.without(shipment.exceptions, _.findWhere(shipment.exceptions, {
            type: 'quality',
        })); // right now we just delete quality exceptions from this page
        document.title = shipment.shipment_id;
        const isDrayage = isIntermodalShipmentType(shipment);
        const { shipment: { carrier, shipper }, accessorials: accessorialRequests, status, missingReferenceNumbersList, } = this.state;
        return (React.createElement("div", { "data-testid": "div-8efdc855" },
            this.state.showGenerateLedgerModal && (React.createElement(GenerateLedgerModal, { show: this.state.showGenerateLedgerModal, equipment: getEquipmentList(this.state.shipment), shipper: shipper, carrier: carrier, shipments: [this.state.shipment], orderId: ((_a = shipment === null || shipment === void 0 ? void 0 : shipment.order) === null || _a === void 0 ? void 0 : _a._id) || null, ledgerType: this.state.ledgerType, onGenerateLedger: this.handleGenerateLedger, onClose: this.handleHideGenerateLedgerModal, useShipmentAddress: true, shipperInvoiceSettings: this.state.shipperInvoiceSettings })),
            this.state.showRerateCostModal && (React.createElement(RerateCostModal, { show: this.state.showRerateCostModal, shipment: this.state.shipment, onRerateCosts: this.handleRerateCosts, onClose: this.handleHideRerateCostModal })),
            this.renderMessages(),
            React.createElement(ShipmentHolds, { shipment: this.state.shipment }),
            React.createElement("div", { "data-testid": "div-a76ce9a7", className: "pt-4" },
                React.createElement(StatusBar, { progress: this.state.progress, regress: this.state.regress, onClose: () => this.props.onClose(), showCloseButton: this.props.showCloseButton, shipment: Object.assign(Object.assign({}, shipment), { missingReferenceNumbersList }), onCreateHold: () => {
                        this.setState({ showHoldModal: true });
                    }, onRemoveCarrier: () => {
                        this.setState({ showConfirmRemoveModal: true });
                    }, onCloneShipment: () => {
                        this.setState({ showCloneShipmentModal: true });
                    }, onSendBOLMailModal: () => {
                        this.setState({ showSendBOLEmailModal: true });
                    }, onSendRATEEmailModal: () => {
                        this.setState({ showSendRATEEmailModal: true });
                    }, onSendDOEMailModal: () => {
                        this.setState({ showSendDOEmailModal: true });
                    }, onAssignDriver: () => {
                        this.setState({ showAssignDriverModal: true });
                    }, onShowCancelShipmentModal: () => {
                        this.setState({ showCancelShipmentModal: true });
                    }, onShipmentTransition: this.handleStateTransition, onModifyAccessorials: () => {
                        if (isIntermodalShipmentType(shipment)) {
                            this.setState({ showAddOrAdjustDrayageAccessorialModal: true });
                        }
                        else {
                            this.setState({ showAddAccessorialModal: true });
                        }
                    }, onBulkAddAccessorial: () => {
                        this.setState({ showBulkAccessorialModal: true });
                    }, onReOpenShipment: () => {
                        this.setState({ showShipmentReOpenModal: true });
                    }, onCloseShipment: ShipmentsActionCreators.closeShipment, onSaveToggleOnHold: ShipmentsActionCreators.updateOnHold, onGenerateCarrier204: this.generateCarrier204, onSaveToggleExposed: ShipmentsActionCreators.updateExposed, onOverrideBillingStatus: () => this.setState({ showOverrideBillingStatusModal: true }) }),
                React.createElement(ShipmentRoute, { shipment: shipment, stops: this.state.stops, waypoints: this.state.waypoints, disableStopActions: isLegManagementEnabled(shipment === null || shipment === void 0 ? void 0 : shipment.order), onWaypointsSelect: this.handleWaypointsSelect.bind(this), showWaypoints: this.state.waypointsEnabled, onStopModified: ShipmentsActionCreators.updateShipmentStop, onStopLoadsModified: ShipmentsActionCreators.updateShipmentStopLoads, onStopWindowModified: ShipmentsActionCreators.updateShipmentStopWindow, onSaveLocationIntentChanges: ShipmentsActionCreators.updateShipmentStopLocation, onSaveReferenceNumbers: ShipmentsActionCreators.updateShipmentStopReferenceNumbers, onUploadStopDocument: ShipmentsActionCreators.uploadStopDocument, onDeleteStopDocument: ShipmentsActionCreators.deleteStopDocument, onCancelStop: ShipmentsActionCreators.cancelStop, onCopyStop: ShipmentsActionCreators.copyStop, onCompleteStop: ShipmentsActionCreators.completeStop, onStopTransition: ShipmentsActionCreators.transitionStop, onSortStops: this.handleSortStops, onAddComment: this.handleAddComment })),
            React.createElement("div", { "data-testid": "div-1af8af11", className: "pt-4" },
                React.createElement(CargomaticCard, { dataTestId: "CargomaticCard-e2f5e4c5", header: () => (React.createElement("header", { "data-testid": "header-9f9c248c", className: "flex items-center space-x-1" },
                        React.createElement("h3", { "data-testid": "h3-bca54c55", className: "my-0 mb-4 text-base" }, t('SHIPMENT_EVENTS')),
                        React.createElement(CargomaticTooltip, { dataTestId: "CargomaticTooltip-85477b4b", id: "shipment_events" }, t('SHIPMENT_EVENTS_TOOLTIP')))) },
                    ' ',
                    shipment && this.state.audits && (React.createElement(Events, { shipment: shipment, audits: this.state.audits, stops: this.state.stops })))),
            React.createElement("div", { "data-testid": "div-4e356072", className: "pt-4" },
                React.createElement(CargomaticCard, { dataTestId: "CargomaticCard-414b8132", header: () => (React.createElement("header", { "data-testid": "header-d8230727", className: "flex items-center space-x-1" },
                        React.createElement("h3", { "data-testid": "h3-63b407f8", className: "my-0" }, t('MARKETPLACE_STATUS')),
                        !isNil(shipment.last_distribution_radius) && (React.createElement(CargomaticTooltip, { dataTestId: "CargomaticTooltip-d2f7f3dd", id: "marketplace_status" }, t('MARKETPLACE_STATUS_TOOLTIP', {
                            last_distribution_radius: unitConverter(shipment.last_distribution_radius)
                                .from('mi')
                                .to(localeData.distance_units)
                                .toFixed(2),
                            distanceUnit: localeData.distance_units,
                        }))))) },
                    React.createElement(MarketplaceStatus, { shipment: shipment, isDrayage: isDrayage }))),
            React.createElement("div", { "data-testid": "div-57bb9168", className: "lg:grid lg:grid-cols-12 lg:gap-8" },
                React.createElement("div", { "data-testid": "div-71894078", className: "lg:col-span-12" },
                    React.createElement("div", { "data-testid": "div-f9326993", className: "pt-6" },
                        React.createElement("div", { "data-testid": "div-02ffcd51", className: "flex flex-wrap items-center space-x-4 mb-4" },
                            React.createElement("h3", { "data-testid": "h3-e93a0deb", className: "my-0 mb-4 text-base" }, t('ACCOUNTING')),
                            this.state.intermodalShipment &&
                                !this.state.shipment.canceled && (React.createElement("div", { "data-testid": "div-b498874f" },
                                React.createElement(DropdownMenu, { dataTestId: "DropdownMenu-6967c335", title: t('ACTIONS') },
                                    !isLegManagementEnabled((_b = this.state.shipment) === null || _b === void 0 ? void 0 : _b.order) && (React.createElement(Menu.Item, { "data-testid": "MenuItem-f13f218e", key: "create_invoice" },
                                        React.createElement(DropdownItem, { dataTestId: "DropdownItem-466ab658", disabled: !this.state.shipment.needs_invoice ||
                                                (featureEnabled(CONFIGURED_FEATURES.SSR) &&
                                                    this.isMissingReferenceNumbers()), onClick: this.handleShowGenerateLedgerModal('receivables') }, t('CREATE_INVOICE')))),
                                    React.createElement(Menu.Item, { "data-testid": "MenuItem-32fcde00", key: "create_payout" },
                                        React.createElement(DropdownItem, { dataTestId: "DropdownItem-a7c3db6e", disabled: !this.state.shipment.needs_payout, onClick: this.handleShowGenerateLedgerModal('payables') }, t('CREATE_PAYOUT'))),
                                    React.createElement(Menu.Item, { "data-testid": "MenuItem-75857402", key: "rerate_costs" },
                                        React.createElement(DropdownItem, { dataTestId: "DropdownItem-3ebb626d", onClick: this.handleShowRerateCostModal }, t('RERATE_COSTS'))),
                                    React.createElement(Menu.Item, { "data-testid": "MenuItem-10cb86e4", key: "send_fees_due_payment" },
                                        React.createElement(DropdownItem, { dataTestId: "DropdownItem-72ecc59f", onClick: this.handleShowSendFeesDueEmailModal }, t('SEND_FEES_PAST_DUE_EMAIL')))))),
                            featureEnabled(CONFIGURED_FEATURES.SSR) &&
                                this.isMissingReferenceNumbers() && (React.createElement(Badge, { dataTestId: "Badge-6825507c", className: "mb-2", color: "red" }, t('MISSING_REFERENCE_NUMBERS'))),
                            isIntermodalShipmentType(shipment) &&
                                !isLegManagementEnabled(shipment === null || shipment === void 0 ? void 0 : shipment.order) && (React.createElement("div", { className: "flex mb-2 items-center space-x-2" },
                                React.createElement(Badge, { dataTestId: "Badge-3a768ca5", color: "blue" }, `${t('INVOICE_GROUPING')}: ${t(((_d = (_c = this.state) === null || _c === void 0 ? void 0 : _c.shipperInvoiceSettings) === null || _d === void 0 ? void 0 : _d.invoice_grouping) || 'UNLIMITED')}`),
                                React.createElement(Badge, { dataTestId: "Badge-17425368", color: "purple" }, `${t('PENDING_ACCESSORIAL_EVALUATION')}: ${this.state.pendingAccessorialInclusion ? t('YES') : t('NO')}`)))),
                        isLegManagementEnabled(shipment === null || shipment === void 0 ? void 0 : shipment.order) && (React.createElement(OrderRtbBanner, { order: shipment === null || shipment === void 0 ? void 0 : shipment.order })),
                        this.renderAccountingPanel(shipment, accessorialRequests))),
                isIntermodalShipmentType(shipment) && (React.createElement("div", { "data-testid": "div-e188759f", className: "lg:col-span-12" },
                    React.createElement(MeteringTable, { shipment: shipment }))),
                isIntermodalShipmentType(shipment) && (React.createElement("div", { "data-testid": "div-4779fb7a", className: "lg:col-span-12" },
                    React.createElement(CargomaticCard, { dataTestId: "CargomaticCard-d6ad0c38", header: () => {
                            var _a, _b;
                            return (React.createElement(React.Fragment, null,
                                React.createElement("div", { "data-testid": "div-a6f145d5", className: "flex items-center justify-between" },
                                    React.createElement("h3", { "data-testid": "h3-bcf38e15", className: "my-0" }, t('ACCESSORIAL_REQUESTS')),
                                    this.renderAccessorialRequestsPanelHeader()),
                                React.createElement("div", { className: "flex items-center space-x-2 mt-2" },
                                    React.createElement(Badge, { color: "blue" }, `${t('INVOICE_GROUPING')}: ${t(((_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.shipperInvoiceSettings) === null || _b === void 0 ? void 0 : _b.invoice_grouping) || 'UNLIMITED')}`),
                                    React.createElement(Badge, { color: "purple" }, `${t('PENDING_ACCESSORIAL_EVALUATION')}: ${this.state.pendingAccessorialInclusion ? t('YES') : t('NO')}`))));
                        } },
                        this.renderAccessorialRequests(shipment),
                        this.renderPane()))),
                isIntermodalShipmentType(shipment) &&
                    featureEnabled(CONFIGURED_FEATURES.MARKET_EXCEPTIONS) && (React.createElement("div", { "data-testid": "div-4779ub7a", className: "lg:col-span-12" },
                    React.createElement(ShipmentBridges, { shipmentId: shipment._id }))),
                React.createElement("div", { "data-testid": "div-89cf407d", className: "lg:col-span-6" },
                    isDrayage && (React.createElement("div", { "data-testid": "div-e1a932d7", className: "pt-6" },
                        React.createElement(HazmatDetails, { order: shipment.order, isEditable: false }))),
                    isDrayage && (React.createElement("div", { "data-testid": "div-e1a932d6", className: "pt-6" }, this.renderPortIntegration(shipment))),
                    React.createElement("div", { "data-testid": "div-2f521ac9", className: "pt-6" },
                        React.createElement(ShipmentDetails, { shipment: shipment, updateMissingReferenceNumbers: this.updateMissingReferenceNumbers, status: status, audits: this.state.audits || null, onReferenceNumbersChange: ShipmentsActionCreators.updateReferenceNumbers, onNotesUpdate: ShipmentsActionCreators.updateShipperNotes, onStackPositionUpdate: ShipmentsActionCreators.updateStackPosition, onAdminNotesUpdate: ShipmentsActionCreators.updateAdminNotes, onTagsUpdate: ShipmentsActionCreators.updateTags, onUpdateEstimatedArrivalChange: (value) => {
                                ShipmentsActionCreators.updateEstimatedArrival(shipment, value);
                            }, onUpdateArrivalDateChange: (value) => {
                                ShipmentsActionCreators.updateArrivalDate(shipment, value);
                            }, onUpdateDischargeDateChange: (value) => {
                                ShipmentsActionCreators.updateDischargeDate(shipment, value);
                            }, onUpdateCustomLfdChange: (value) => {
                                ShipmentsActionCreators.updateCustomLfd(shipment, value);
                            }, onUpdateAvailableDateChange: (value) => {
                                ShipmentsActionCreators.updateAvailableDate(shipment, value);
                            }, onUpdateLastFreeDateChange: (value) => {
                                ShipmentsActionCreators.updateLastFreeDate(shipment, value);
                            }, onUpdateYardLastFreeDateChange: (value) => {
                                ShipmentsActionCreators.updateYardLastFreeDate(shipment, value);
                            }, onUpdateYardAvailableDateChange: (value) => {
                                ShipmentsActionCreators.updateYardAvailableDate(shipment, value);
                            }, onUpdateEmptyReturnedDateChange: (value) => {
                                ShipmentsActionCreators.updateEmptyReturnedDate(shipment, value);
                            }, onUpdateLastCutDateChange: (value) => {
                                ShipmentsActionCreators.updateLastCutDate(shipment, value);
                            }, onUpdateDocumentCutoffDateChange: (value) => {
                                ShipmentsActionCreators.updateDocumentCutoffDate(shipment, value);
                            }, onUpdateEarliestReturnDateChange: (value) => {
                                ShipmentsActionCreators.updateEarliestReturnDate(shipment, value);
                            }, onUpdateEarliestEmptyDateChange: (value) => {
                                ShipmentsActionCreators.updateEarliestEmptyDate(shipment, value);
                            }, onUpdateEmptyReadyForPickupDateChange: (value) => {
                                ShipmentsActionCreators.updateEmptyReadyForPickupDate(shipment, value);
                            }, onUpdatePerDiemDateChange: (value) => {
                                ShipmentsActionCreators.updatePerDiemDate(shipment, value);
                            }, onUpdateOutgatedDateChange: (value) => {
                                ShipmentsActionCreators.updateOutgatedDate(shipment, value);
                            }, onShipmentTypeChange: (value) => {
                                ShipmentsActionCreators.updateShipmentType(shipment, value);
                            }, onEquipmentTypeChange: (value) => {
                                this.handleUpdateShipmentEquipmentType(shipment, value);
                            }, onExceptionExemptChange: (value) => {
                                ShipmentsActionCreators.updateExceptionExemptFlag(shipment, value);
                            }, onPODValidChange: (podType) => {
                                ShipmentsActionCreators.updatePODValid(shipment, (podType === null || podType === void 0 ? void 0 : podType.value) ? podType.value : podType);
                            }, onAddComment: this.handleAddComment, onUpdateRailEvent: (event, value) => {
                                ShipmentsActionCreators.updateRailEvent(shipment, event, value);
                            }, onUpdateImportantDates: (event, value) => {
                                ShipmentsActionCreators.updateImportantDates(shipment, event, value);
                            } }))),
                React.createElement("div", { "data-testid": "div-1f098c3f", className: "lg:col-span-6" },
                    React.createElement("div", { "data-testid": "div-ec3bafbf", className: "pt-6" },
                        React.createElement(CargomaticCard, { dataTestId: "CargomaticCard-f93b0190", header: () => (React.createElement("header", { "data-testid": "header-563e9ed5", className: "flex items-center space-x-1" },
                                React.createElement("h3", { "data-testid": "h3-f61f74d4", className: "my-0" }, t('DOCUMENTS')),
                                React.createElement(CargomaticTooltip, { dataTestId: "CargomaticTooltip-74bc9023", id: "document_list" }, t('DOCUMENT_LIST_SUPPORTED_FORMATS')),
                                isDrayageOrRailShipment(shipment) && (React.createElement(ShipmentInvoiceDocumentPreferences, { preferences: shipper.invoice_document_preferences })))) },
                            React.createElement(Documents, { onDelete: (document) => {
                                    console.log('Deleted Document: ', document);
                                }, onUpload: (shipment, type, documents) => {
                                    console.log('Uploaded Documents: ', documents);
                                }, shipment: shipment, isOrder: false, refetchRef: (documentsRefetch) => this.setDocumentsRefetchRef(documentsRefetch) }))),
                    React.createElement("div", { "data-testid": "div-743f3f33", className: "pt-6" },
                        React.createElement(CargomaticCard, { dataTestId: "CargomaticCard-37912872", header: () => (React.createElement("h3", { "data-testid": "h3-1d612f34", className: "my-0" }, t('DISCUSSION'))) },
                            React.createElement(CommentList, { paginate: true, itemsPerPage: 10, id: shipment._id, comments: shipment.comments, onCommentAdd: this.handleAddComment }))))),
            React.createElement(CloneShipmentModal, { onClone: this.handleCloneShipment, onHide: this.handleCloseCloneShipmentModal, show: this.state.showCloneShipmentModal }),
            React.createElement(AddAccessorialModal, { shipment: shipment, show: this.state.showAddAccessorialModal, addAccessorial: ShipmentsActionCreators.addAccessorial, removeAccessorial: ShipmentsActionCreators.removeAccessorial, accessorialError: this.state.accessorialError, requireApproval: shipment.shipper.requires_accessorial_approval, onHide: () => this.setState({ showAddAccessorialModal: false }) }),
            React.createElement(ShipperCostAdjustmentModel, { shipment: shipment, selectedLineItem: this.state.selectedLineItemForAdjustment, show: this.state.showShipperChargeAdjustmentModal, equipments: getEquipmentList(shipment), onSave: this.handleShipperCostAdjustment, onHide: this.handleHideShipperCostAdjustmentModel }),
            this.state.showAddOrAdjustDrayageAccessorialModal && (React.createElement(AddOrAdjustDrayageAccessorialModal, { shipment: shipment, show: this.state.showAddOrAdjustDrayageAccessorialModal, customAdjustment: this.state.customAdjustment, equipment: getEquipmentList(shipment), onSave: this.handleAddCustomAccessorial, onHide: this.handleHideCustomAccessorialModal, onRemoveAdjustment: this.handleRemoveAdjustment, onEditAdjustment: this.handleEditAdjustment })),
            React.createElement(AssignDriverModal, { shipments: [], shipment: shipment, show: this.state.showAssignDriverModal, onAssignDriver: ShipmentsActionCreators.assignDriver, onAssignBrokerCarrier: (shipment, driver) => this.setState({
                    showConfirmAssignCarrierModal: true,
                    showAssignDriverModal: false,
                    brokerCarrierDriver: driver,
                }), onHide: () => this.setState({ showAssignDriverModal: false }) }),
            React.createElement(ConfirmAssignCarrierModal, { isOpen: this.state.showConfirmAssignCarrierModal, brokerCarrierDriver: this.state.brokerCarrierDriver, shipment: { _id: shipment._id }, onConfirm: ShipmentsActionCreators.assignDriver, onClose: () => this.setState({ showConfirmAssignCarrierModal: false }) }),
            React.createElement(AddIncentiveModal, { show: this.state.showIncentiveModal, addIncentive: this.addIncentive(), onHide: () => this.setState({ showIncentiveModal: false }) }),
            React.createElement(CancelShipmentModal, { shipment: shipment, onCancelShipment: ShipmentsActionCreators.cancelShipment, show: this.state.showCancelShipmentModal, onHide: () => this.setState({ showCancelShipmentModal: false }) }),
            React.createElement(SendBolEmailModal, { shipment: shipment, show: this.state.showSendBOLEmailModal, onSend: this.sendBolEmail(), onHide: () => this.setState({ showSendBOLEmailModal: false }) }),
            React.createElement(SendRATEEmailModal, { shipment: shipment, show: this.state.showSendRATEEmailModal, onHide: () => this.setState({ showSendRATEEmailModal: false }) }),
            React.createElement(SendDOEmailModal, { show: this.state.showSendDOEmailModal, onSend: this.sendDeliveryOrder(), onHide: () => this.setState({ showSendDOEmailModal: false }), defaultRecipient: deliveryOrderRecipient }),
            React.createElement(ShipmentReopenModal, { show: this.state.showShipmentReOpenModal, transition: ShipmentsActionCreators.transitionTo, shipment: shipment, onHide: () => this.setState({ showShipmentReOpenModal: false }) }),
            this.state.showBulkAccessorialModal && (React.createElement(BulkAddAccessorialsModal, { show: this.state.showBulkAccessorialModal, orderId: shipment.order._id || null, shipmentIds: [shipment].map((s) => s._id), onSave: this.handleBulkCreateAccessorials, onHide: () => this.setState({
                    showBulkAccessorialModal: false,
                    bulkAccessorialModalEditMode: false,
                }), edit: this.state.bulkAccessorialModalEditMode, selectedAccessorials: this.state.selectedAccessorialRequests.map((acc) => acc._id) })),
            React.createElement(ConfirmModal, { dataTestId: "ConfirmModal-68dfa1c1", show: this.state.showConfirmRemoveModal, title: t('CONFIRM_ACTION'), message: t('REMOVE_CARRIER_CONFIRMATION'), onHide: () => this.setState({ showConfirmRemoveModal: false }), onConfirm: this.removeCarrier }),
            React.createElement(ConfirmModal, { dataTestId: "ConfirmModal-2f9399c4", show: this.state.showConfirmModal, title: this.state.confirmModalTitle, message: this.state.confirmModalMessage, onHide: this.handleCancelConfirmModal, onConfirm: this.handleRemoveAdjustmentConfirm }),
            this.state.showConfirmStateTransitionModal && (React.createElement(ConfirmModal, { dataTestId: "ConfirmModal-ef83f34b", show: this.state.showConfirmStateTransitionModal, title: t('STATUS_CHANGE_CONFIRMATION_TITLE'), message: this.getStateTransitionMessage(this.state.nextState.status), onHide: this.handleHideConfirmStateTransitionModal, onConfirm: () => this.handleConfirmStateTransitionModal() })),
            this.state.accessorialAction && (React.createElement(AccessorialsConfirmationModal, { show: true, action: this.state.accessorialAction, onHide: () => this.setState({ accessorialAction: '' }), shipmentId: shipment._id, selectedAccessorials: this.state.selectedAccessorialRequests.map((acc) => acc._id), onAccessorialSubmit: this.handleAccessorialOnSubmit, handleAccessorialRemove: this.handleAccessorialRemove })),
            this.state.showHoldModal && (React.createElement(ShipmentOnHoldModal, { hold: {}, setShowHoldModal: (show) => this.setShowHoldModal(show), onSave: (hold) => this.onSaveHold(hold), timezone: this.state.timezone, loading: this.state.isLoadingHolds })),
            this.state.showSendFeesDueEmailModal && (React.createElement(SendEmailModal, { action: t('SEND_FEES_DUE_PAYMENT_LINK'), show: this.state.showSendFeesDueEmailModal, onSend: (recipients) => ShipmentWebAPIUtils.sendFeesDuePaymentLink(shipment._id, recipients), onHide: this.handleHideSendFeesDueEmailModal })),
            this.state.showOverrideBillingStatusModal && (React.createElement(OverrideBillingStatusModal, { shipmentIds: [shipment._id], open: this.state.showOverrideBillingStatusModal, onHide: this.handleHideOverrideBillingStatusModal, onSuccess: () => this.refreshShipment() })),
            React.createElement(FloatingAIAssistant, { shipmentId: shipment.shipment_id })));
    }
}
Shipment.propTypes = {
    match: PropTypes.object,
};
export default withTranslation()(withLocaleContext(Shipment));
function getEquipmentList(shipment) {
    return _.uniq(shipment.stops.reduce((equipmentList, stop) => equipmentList.concat(stop.equipments), []), (equipment) => equipment._id);
}
function getIdParam(props) {
    const { modalID, match, shipment } = props;
    const params = (match || {}).params || {};
    return modalID || params.id || shipment._id;
}
const getAccessorialRequestIds = (requests) => (requests || []).map((r) => r._id);
const getAccessorialRequestIdsWithMissingDocs = (requests) => (requests || []).filter((r) => r.missing_docs).map((r) => r._id);
